import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/reports/')({
  component: () => <Navigate to="/reports/quarterly" />,
})
